// extracted by mini-css-extract-plugin
export var li = "_te-2";
export var ol = "_te-1";
export var ul = "_te-0";